export const frontmatter = {
    "draft": true,
    "title": "Node.js / TypeScript SDK",
    "description": "Official OnnIA library to integrate flows, messaging, and agents in Node.js and TypeScript applications.",
    "sidebar_label": "Node.js / TS",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = [
    {
        "depth": 2,
        "id": "installation",
        "value": "Installation"
    },
    {
        "depth": 2,
        "id": "initialization",
        "value": "Initialization"
    },
    {
        "depth": 2,
        "id": "usage-examples",
        "value": "Usage examples"
    },
    {
        "depth": 3,
        "id": "send-a-message-via-channel",
        "value": "Send a message via channel"
    },
    {
        "depth": 3,
        "id": "start-workflow-execution",
        "value": "Start Workflow execution"
    }
]